import { useEffect, useState } from 'react';

/**
 * Live width (px) of the element in `ref`, or `null` before it has been
 * measured. Unlike Tailwind's `lg:` breakpoints this follows the element's own
 * size, so a toolbar squeezed by a side panel reacts even on a wide screen.
 */
export default function useElementWidth(ref) {
  const [width, setWidth] = useState(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    setWidth(el.getBoundingClientRect().width);
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);
  return width;
}
